module.exports = __webpack_public_path__ + "img/facility2.363338ab.png";